import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './setupFetch';
import { I18nProvider } from './i18n/I18nProvider';
// In development, proxy /api calls to backend port via fetch wrapper

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
);

// Force English validation messages for required fields
// Customize the default browser message "Please fill out this field."
try {
  window.addEventListener('invalid', function (e) {
    const t = e.target;
    if (t && t.validity && t.validity.valueMissing) {
      const locale = localStorage.getItem('lexilab.locale');
      t.setCustomValidity(locale === 'zh-CN' ? '请填写此字段。' : 'Please fill out this field.');
    }
  }, true);
  window.addEventListener('input', function (e) {
    const t = e.target;
    if (t && typeof t.setCustomValidity === 'function') {
      t.setCustomValidity('');
    }
  }, true);
} catch (_) {}
